module.exports = __webpack_public_path__ + "static/img/icon_snb_remt_svc_active.4f71b23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_remt_svc_active.svg
// module id = w29K
// module chunks = 10